<template>
  <v-container background fluid pa-4 >
    <v-layout row wrap pa-0 style="background-color:#fff;  border-radius:5px;" >
      <v-flex xs12 pa-3>
        <v-form ref="form" v-model="form_valid" >
          <v-layout row wrap >
            <v-flex xs12  id="img_container">
                <img src="../../assets/company.png" />
            </v-flex>
            
            </v-layout>
             <v-layout row wrap >
            <v-flex md2 sm4 xs12 offset-md4 offset-sm2  style="margin-right:15px;" >
              <v-btn color="warning" block class="white--text" @click="DownloadExampleExcel()">
                <p style=" font-size:12px;position: absolute;margin-top:15px;">{{$t('DownloadExample')}}</p>
              </v-btn>
            </v-flex>
            <v-flex md2 sm4 xs12 class="button-wrapper">
              <span class="label">{{$t('Upload')}}</span>
              <input
                :label="$t('ImportIncome')"
                type="file"
                id="file"
                ref="myFiles"
                class="upload-box"
                multiple
                @change="ImportExcel()"
                placeholder="Upload File"
              />
            </v-flex>
          </v-layout>
        </v-form>
        <v-flex md12 sm12 xs12>
          <v-layout row wrap v-if="IncomeData.length != 0">
            <v-flex md12 sm12 xs12 v-for="(item, index) in IncomeData" :key="index" @click="''">
              <v-card class="coco-box-shadow coco-list-hover">
                <v-layout align-center justify-center row fill-height wrap class="coco-list-layout">
                  <v-flex lg9 md9 sm8 xs9>
                   <v-layout row wrap>
                    <v-flex xs12>
                      <span class="coco-list-label-text">{{isEmpty(item.code)? item.code : 'code'}}:</span>

                      <span
                        v-html="' (<span style=color:#166BFF;>'+(isEmpty(item.name) ? item.name : 'name')+'</span>)'"
                      />
                      <span class="coco-list-label-text">
                        {{$t('remark') + ': '}}
                        <span>
                          {{isEmpty(item.remark)?
                          item.remark : 'remark'}}
                        </span>
                      </span>
                    </v-flex>
                    <!-- <v-flex xs12>
                      <span class="coco-list-label-text">
                        {{$t('remark') + ': '}}
                        <span>
                          {{isEmpty(item.remark)?
                          item.remark : 'remark'}}
                        </span>
                      </span>
                    </v-flex> -->
                  </v-layout>
                  </v-flex>
                  <v-flex lg2 md2 sm2 xs12>
                    <v-layout row wrap>
                      <v-flex md12 sm12 xs12 text-xs-right>
                        <v-layout row wrap text-xs-right>
                          <v-flex offset-lg5 offset-md3 offset-xs4 lg3 md4 xs6 >
                            <v-tooltip bottom>
                              <v-btn
                                slot="activator"
                                color="warning"
                                icon
                                flat
                                @click="EditItem(item,index)"
                              >
                                <v-icon>edit</v-icon>
                              </v-btn>
                              <span>{{$t('edit')}}</span>
                            </v-tooltip>
                          </v-flex>
                          <v-flex lg3 md4 xs2>
                            <v-tooltip bottom>
                              <v-btn
                                slot="activator"
                                color="error"
                                icon
                                flat
                                @click="deleteItem(item,index)"
                              >
                                <v-icon>delete</v-icon>
                              </v-btn>
                              <span>{{$t('delete')}}</span>
                            </v-tooltip>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>

                  <v-flex xs12 class="coco-list-divider">
                    <v-divider />
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
            <v-flex xs12 text-xs-right>
              <v-btn color="#D84315" @click="back()">
                <v-icon class="mr-2" style="color:#ffffff">fas fa-arrow-left</v-icon>
                <span style="color:#ffffff">{{$t('back')}}</span>
              </v-btn>
              <v-btn color="#43A047" @click="dialog = false;onSave()">
                <v-icon class="mr-2" style="color:#ffffff">save</v-icon>
                <span style="color:#ffffff">{{$t('save')}}</span>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-flex>
      <!-- Delete Dialog -->
      <v-flex md12 sm12 xs12>
        <delete-dialog
          :json_data="delete_dialog_data"
          v-on:close-dialog="onCloseDeleteDialog"
          v-on:delete-item="onDelete"
        />
      </v-flex>
      <!-- FormEdit -->
      <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline">{{$t('menu.EmployeeEdit')}}</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md6>
                    <v-text-field :label="$t('branch_code')"  type="text" v-model="form_dialog.code" required></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6 md6>
                    <v-text-field :label="$t('branch_name')"  type="text" v-model="form_dialog.name" required></v-text-field>
                  </v-flex>
                   <v-flex xs12 sm6 md6>
                    <v-text-field :label="$t('remark')" type="text" v-model="form_dialog.remark" required></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="dialog = false">Close</v-btn>
              <v-btn color="blue darken-1" flat @click="dialog = false;onUpdate()" v-if="permission_edit == true || admin == 'true'">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
     
      <!-- Snackbar -->
      <v-snackbar
        v-model="snack_model.status"
        :timeout="3500"
        :top="'top'"
        :color="snack_model.type"
      >
        {{ snack_model.msg }}
        <v-btn dark flat icon @click="snack_model.status = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-layout>
  </v-container>
</template>
<script>
/* eslint-disable */
import { mapState, mapActions } from "vuex";
import DocumentService from "@/services/DocumentService";
import SettingService from "@/services/SettingService";
import EmployeeService from "@/services/EmployeeService";
import DeleteDialog from "../../components/master/dialogs/DeleteDialog";
import UserService from "@/services/UserService";
import Empimage from "../../components/getempimage.vue";
import XLSX from "xlsx";
import moment, { locale } from "moment";
import Utils from "@/utils/";
import { constants } from "crypto";
export default {
  data: () => ({
    dialog_create: false,
    isChecked: false,
    form_valid: false,
    dialog: false,
    form_dialog_data: {
      status: false,
      save_type: String,
      data: Object
    },
    delete_dialog_data: {
      status: false
    },
    snack_model: {
      status: "",
      msg: "",
      type: ""
    },
    index: 0,
    form_dialog: {
      code: "",
      name: "",
      remark: "",
    },
    form_model:{
      code: "",
      name: "",
      remark: "",
      editorCode: localStorage._usercode
    },
    form_dialog_create: {
      name_doc: "",
      date: "",
      remark: ""
    },
    head_example: [ "รหัสสาขา","ชื่อสาขา", "หมายเหตุ"],
    detail_example: [],
    details: [],
    results: [],
    IncomeData: [],
    name: [],
    checkdata: true,
    permission_edit:false,
    permission_view:false,
    admin:false,
    empCode: localStorage._empcode,
    permission:[]
  }),

  components: {
    DeleteDialog,
    Empimage
  },
  computed: {
    ...mapState("app", [
      "showLoading",
      "formatDates",
      "symbolStyles",
      "currencySymbols"
    ]),
   // ...mapState("permissionmenu", ["permission_List"]),

    selectAllEmp() {
      return this.name.length === this.Employee_List.length;
    },
    selectSomeEmp() {
      console.log(this.name);
      return this.name.length > 0 && !this.selectAllEmp;
    }
  },
  created:async function() {
    //this.doNewGuid();
    this.admin = localStorage.is_admin;
      await  UserService.getpermissionByusercode(this.empCode)
    .then(res=>{
      this.permission = res.data.permission;
      console.log(res)
    })
     .catch(err => {});
     await this.checkpermission("ImportBranch");
    console.log(this.check_permission)
    this.commitSetToolbar({ patternTool: "0" });
    this.getEmployee();
  },
  methods: {
    ...mapActions("filter", ["getEmployee"]),
    ...mapActions("app", ["commitSetToolbar"]),
    goto(path) {
      this.$router.push("/" + path);
    },
    isEmpty(value) {
      return Utils.isEmpty(value);
    },
    doNewGuid() {
      this.emp_code = Utils.newGuid("EMP");
    },
      checkpermission(page){
        let checkEdit = false
        let checkView = false
        if(this.permission.length != 0){
             this.permission.forEach(element => {
                 if(page == element.module_name){
                    checkEdit = element.edit;
                    checkView = element.reads;
                 }
             });
        }
        else{
            checkEdit = false;
            checkView = false;
        }
        this.permission_edit = checkEdit
        this.permission_view = checkView
    },
    DownloadExampleExcel() {
      let v = this;
      console.log("DownloadExampleExcel");
      console.log(v.name);
      v.head_example =[];
      v.detail_example = [];
      
        v.detail_example.push({
           รหัสสาขา:"00000",
           ชื่อสาขา:"สำนักงานใหญ่", 
           หมายเหตุ:"-", 
          });
        
      console.log(v.detail_example)
        var config = { raw: true, type: "string" };
          var Example = XLSX.utils.json_to_sheet(
          v.detail_example,
          v.head_example,
          config
        );
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, Example, "ImportBranch" );
        XLSX.writeFile(wb, "ImportBranch.xlsx");
    },
    ImportExcel() {
      let v = this;
      var config = { raw: true, type: "string" };
      var reader = new FileReader();
      reader.readAsArrayBuffer(this.$refs.myFiles.files[0]);
      reader.onload = function(e) {
        var data = new Uint8Array(reader.result);
        var wb = XLSX.read(data, { type: "array" });
        var firstSheetName = wb.SheetNames[0];
        var worksheet = wb.Sheets[firstSheetName];
        v.results = XLSX.utils.sheet_to_json(worksheet, config);
        console.log(v.results);
         v.details = [];
        for (let index = 0; index < v.results.length; index++) {
        // v.doNewGuid();
       
            if (
            v.results[index].รหัสสาขา != " " && 
            v.results[index].ชื่อสาขา != " " &&
            v.results[index].หมายเหตุ != " " &&
             v.results[index].รหัสสาขา != undefined &&
            v.results[index].ชื่อสาขา != undefined  &&
            v.results[index].หมายเหตุ != undefined 
          ) {
            v.details.push({
              code: v.results[index].รหัสสาขา,
              name: v.results[index].ชื่อสาขา,
              remark: v.results[index].หมายเหตุ,
            });
          }
           else if (
            v.results[index].รหัสสาขา == undefined ||
            v.results[index].ชื่อสาขา == undefined  ||
            v.results[index].หมายเหตุ == undefined 
          ){
            v.snack_model.status = true;
            v.snack_model.msg = "เอกสารไม่ถูกต้องกรุณาอัพโหลดเอกสารใหม่";
            v.snack_model.type = "error";

          } else {
            v.snack_model.status = true;
            v.snack_model.msg = "กรุณากรอกข้อมูลให้ครบถ้วน";
            v.snack_model.type = "error";
          } 
        }
        console.log(v.details);
         v.IncomeData = v.details;
      
      };
      reader.onerror = function(e) {
        this.snack_model.status = true;
        this.snack_model.msg = "กรุณากรอกข้อมูลให้ครบถ้วน";
        this.snack_model.type = "error";
      };
    },
    onCloseDeleteDialog() {
      this.delete_dialog_data.status = false;
    },
    deleteItem(data, index) {
      this.delete_dialog_data.status = true;
      let message =
        "<p>" +
        this.$t("question.delete") +
        " " +
        data.code +
        " " +
        data.name +
        "?</p>";
      this.delete_dialog_data.message = message;
      this.delete_dialog_data.index = index;
    },
    EditItem(data, index) {
      this.dialog = true;
      this.form_dialog = data;
      this.index = index;
    },

    onDelete() {
      console.log(this.delete_dialog_data.index);
      this.IncomeData.splice(this.delete_dialog_data.index, 1);
      this.details.splice(this.delete_dialog_data.index, 1);
      console.log("ondelete: importincome", this.details);
    },
    timedRefresh(timeoutPeriod) {
      setTimeout("location.reload(true);", timeoutPeriod);
    },
    onSave() {
      let v = this;

      v.IncomeData.forEach(data => {
        if (data.status == false) {
          v.checkdata = false;
        }
      });

      console.log(v.checkdata);
      if (v.checkdata != false) {
        console.log("dddd"+this.details);

        if (this.form_valid) {
          this.details.forEach(element => {
            v.name.push({
              code :element.code,
              name :element.name,
              remark :element.remark,
              company_id : localStorage._company_guid,
            })
             console.log(v.name)
          });
         
          SettingService.saveBranchList(v.name)
            .then(res => {
              this.dialog_loading = false;
                v.snack_model.status = true;
                v.snack_model.msg = v.$t("message.save");
                 v.snack_model.type = "success";
                  v.goto("branch/list");
              // this.closeDialog();
            })
            .catch(err => {
              console.log(err);
              this.dialog_loading = false;
              this.snackbar = true;
              this.errmsg = err;
            });
        }

      } else {
        v.snack_model.status = true;
        v.snack_model.msg = "กรุณาตรวจสอบข้อมูลและทำการอัพโหลดไฟล์ใหม่";
        v.snack_model.type = "error";
        window.onload = this.timedRefresh(1500);
      }
    },

    onUpdate() {
      let v = this;
        (v.details[v.index].code = v.form_dialog.code),
        (v.details[v.index].name = v.form_dialog.name),
        (v.details[v.index].remark = v.form_dialog.remark),
        (this.snack_model.status = true);
      this.snack_model.msg = this.$t("message.update");
      this.snack_model.type = "success";
    },
    back() {
      location.reload();
    },
    toggle() {
      this.$nextTick(() => {
        console.log(this.selectAllEmp);
        if (this.selectAllEmp) {
          this.name = [];
          this.isChecked = false;
        } else {
          this.isChecked = true;
          this.name = [];
          this.Employee_List.forEach(data => {
            this.name.push(data.name);
          });
        }
      });
    }
  }
};
</script>
<style>
@import url("https://fonts.googleapis.com/css?family=Kanit&display=swap");
้ h1,
h2,
h3,
h4,
h5,
h6,
span,
p {
  font-family: "Kanit", sans-serif;
}
.v-input--selection-controls {
  margin-top: 0;
}
.button-wrapper {
  position: relative;
  width: 150px;
  text-align: center;
  margin-top: 5px;
  margin-right: 15px;
  margin-bottom: 5px;
}

.button-wrapper span.label {
  position: relative;
  display: inline-block;
  width: 100%;
  background: #00bfff;
  cursor: pointer;
  color: #fff;
  padding: 10px 0;
  text-transform: uppercase;
  font-size: 12px;
  box-shadow: 0px 2px 2px grey;
}

#file {
  display: inline-block;
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 50px;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
}
.checkEmp .theme--light.v-icon {
  color: #1976d2 !important;
}#img_container {
  width: 100px;
  display: table-cell;
  vertical-align: middle;
}
#img_container img {
  height: 100px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 10px;
  margin-bottom: 20px;
  display: block;
}
</style>
